module.exports = __webpack_public_path__ + "img/fluent-arrow.b42218ac.svg";